import React, { Component } from 'react'
import { List, ListItem } from 'material-ui/List'
import IconButton from 'material-ui/IconButton'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';

import { getMemberRecordById, getMemberInviteStatus } from '../../../core/groups'
class GroupItem extends Component {

  constructor(props, context) {
    super(props, context)
    this.acceptInvite = this.acceptInvite.bind(this)
    this.rejectInvite = this.rejectInvite.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.group !== this.props.group
  }

  acceptInvite() {
    console.log('Button');
    this.props.onGroupAccept(this.props.group)
  }

  rejectInvite() {
    this.props.onGroupReject(this.props.group)
  }

  render() {
    const { group } = this.props
    //const displayText = `Creator: ${group.creatorEmail}, Leader: ${group.leaderEmail}, Size: ${group.groupSize}, Confirmed: ${group.isConfirmed}, Disbanded: ${group.isDisbanded ? true : false}, Accepts: ${group.numAccepts}, Rejects: ${group.numRejects}`

    const confirmed = `Confirmed: ${group.isConfirmed ? "Yes" : "No"}`
    const disbanded = `Disbanded: ${group.isDisbanded ? "Yes" : "No"}`
    let memberEmailString = ``
    const groupSize = group.groupSize

    for (let i = 0; i < groupSize; i++) {
      const memberRecord = getMemberRecordById(group, i)
      memberEmailString += ` ${memberRecord.email} (${memberRecord.inviteStatus}) |`
    }

    if (this.props.onGroupAccept && this.props.onGroupReject) {
      const iconButtonElement = (
        <div>
        {/* }<IconButton
          touch={true}
          tooltip="Accept Invitation"
          tooltipPosition="bottom-left"
          onTouchTap={this.acceptInvite}
        >
          <CheckCircle color={grey400} />
        </IconButton> */}


            <RaisedButton className="button-spacing" label="Accept" secondary={true} onTouchTap={this.acceptInvite} />
            <RaisedButton label="Reject" onTouchTap={this.rejectInvite} />

        </div>
      )
      return (
          //<ListItem primaryText={`Size: ${group.groupSize}`} rightIconButton={iconButtonElement} disabled={group.isDisbanded} />

        <List className="pad-left">
          <p>Group Lottery #: {group.groupLotteryNumber}</p>
          <p><b>Creator: {group.creatorEmail}</b></p>
          <p><b>Leader: {group.leaderEmail}</b></p>
          <p>{confirmed}</p>
          <p>{disbanded}</p>
          <p>Group Size: {group.groupSize}</p>
          <p>Number of Accepts: {group.numAccepts}</p>
          <p>Members: {memberEmailString}</p>
          <p>{iconButtonElement}</p>


        </List>
      )
    } else {
      return (
        <List className="pad-left">
        <p>Group Lottery #: {group.groupLotteryNumber}</p>

          <p><b>Creator: {group.creatorEmail}</b></p>
          <p><b>Leader: {group.leaderEmail}</b></p>
          <p>{confirmed}</p>
          <p>{disbanded}</p>
          <p>Group Size: {group.groupSize}</p>
          <p>Number of Accepts: {group.numAccepts}</p>
          <p>Members: {memberEmailString}</p>
        </List>


      )
    }
  }
}

export default GroupItem



// WEBPACK FOOTER //
// ./src/views/components/group-item/index.js